"use client"
//-----------------------------------------------------------------------------
//
// layout_static.js
//
// Copyright 2024 Emergence Software Pte. Ltd. - All rights reserved.
//
//-----------------------------------------------------------------------------

// Imports
import * as React from "react"
import PropTypes from "prop-types"

import EmergenceFooter from "./footer"
import EmergenceHeader from "./header"
import "./layout.scss"


//-----------------------------------------------------------------------------
//
// LAYOUT
//
//-----------------------------------------------------------------------------

// Function LayoutStatic
const LayoutStatic = ({ children, title, titleChange=undefined, noTitleBlock=false }) =>
{
  return (<>
            <EmergenceHeader title={title} titleChange={titleChange} noTitleBlock={noTitleBlock} />
            <main>
              {children}
            </main>
            <EmergenceFooter />
          </>)
}


// Property definitions
LayoutStatic.propTypes = {
  children: PropTypes.node.isRequired,
}


// Default export
export default LayoutStatic
